<template>
  <v-card outlined class="rounded-lg">
    <v-card-title>
      Rechnungen {{ kasse }}
      <v-spacer></v-spacer>
      <v-chip label small>{{ status }}</v-chip>
    </v-card-title>
    <v-simple-table dense fixed-header no-data-text="Keine Striche vorhanden" class="rounded-lg">
      <thead>
        <tr>
          <th>Empfänger</th>
          <th class="text-right">Summe</th>
          <!-- <th class="text-right">Zahlbar bis</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in rechnungen" :key="item.name" v-on:dblclick="(showRechnung = true) && (rechnungid = item.id)">
          <td>{{ $filters.user(item.bbrID, bbrbbr) }}</td>
          <td class="text-right">{{ item.summe | money }}</td>
          <!-- <td class="text-right">{{ item.rechnung_zahlbar_bis, 'DD.MM.YYYY' | date }}</td> -->
        </tr>
        <tr v-if="anzahlRechnungen > 10">
          <td colspan="3" class="text-center">{{ anzahlRechnungen - 10 }} weitere Rechnungen</td>
        </tr>
      </tbody>
    </v-simple-table>
    <div v-if="rechnungen.length === 0" class="text-center caption pa-3">Keine Rechnungen vorhanden</div>
    <dialogRechnung
      :visible.sync="showRechnung"
      :rechnungid="rechnungid"
      @close="showRechnung = false"
    ></dialogRechnung>
  </v-card>
</template>

<script>
  export default {
    props: ["kasse", "status"],
    data() {
      return {
        anzahlRechnungen: 0,
        showRechnung: false,
        rechnungid: "",
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      rechnungen() {
        let rechnungen = this.$store.getters["rechnungen/statusRechnungenKasse"](this.status, this.kasse);
        this.anzahlRechnungen = rechnungen.length;
        return rechnungen.slice(0, 10);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// rechnungenStatus.vue?21b4a89a